(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["judgeme-review-widget"] && !Shopify.designMode) return;
  try {
    (function () {
    function activateReviewTab() {
      var tabLink = document.querySelector('#nav-tab-info a[href="#gtab2"]');
      var tabPane = document.getElementById('gtab2');

      if (tabLink && tabPane && !tabLink.classList.contains('active')) {
        tabLink.parentElement.querySelectorAll('.nav-link').forEach(function (link) {
          link.classList.remove('active');
          link.setAttribute('aria-selected', 'false');
        });
        tabLink.classList.add('active');
        tabLink.setAttribute('aria-selected', 'true');

        tabPane.parentElement.querySelectorAll('.tab-pane').forEach(function (pane) {
          pane.classList.remove('show', 'active');
        });
        tabPane.classList.add('show', 'active');
      }

      var accordionTrigger = document.querySelector('[data-target="#collapseThree"]');
      var accordionPanel = document.getElementById('collapseThree');
      if (accordionTrigger && accordionPanel && !accordionPanel.classList.contains('show')) {
        accordionPanel.classList.add('show');
        accordionTrigger.classList.remove('collapsed');
        accordionTrigger.setAttribute('aria-expanded', 'true');
      }
    }

    function scrollToReviews() {
      var widget = document.getElementById('judgeme_product_reviews');
      if (!widget) return;
      var offset = 250;
      var top = widget.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    }

    document.addEventListener('click', function (event) {
      var badge = event.target.closest('.jdgm-preview-badge');
      if (!badge) return;
      if (!document.getElementById('judgeme_product_reviews')) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      activateReviewTab();

      requestAnimationFrame(function () {
        requestAnimationFrame(scrollToReviews);
      });
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
